export default "__VITE_ASSET__9b0e02a6__"